<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 d-inline-block mb-0">
            {{ $t("menu.agent_number") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>

        <div class="col-lg-6 col-5 text-right">
          <router-link
            :to="{ name: 'import_number' }"
            class="btn btn-sm"
            v-if="isDtacAdmin"
          >
            <base-button size="md" type="neutral">{{
              $t("import")
            }}</base-button>
          </router-link>
          <router-link
            :to="{ name: 'number_create' }"
            class="btn btn-sm"
            v-if="isDtacAdmin"
          >
            <base-button size="md" type="neutral">{{ $t("new") }}</base-button>
          </router-link>
          <base-button
            v-if="isDtacAdmin"
            size="md"
            type="neutral"
            @click="runExport"
            :disabled="exporting"
          >
            {{ $t("export.button") }}
          </base-button>
        </div>
      </div>
    </base-header>

    <modal :show.sync="exporting" :show-close="false" modal-classes="modal-sm">
      <div class="text-center py-3">
        <i class="fa fa-spinner fa-spin fa-2x text-primary mb-2"></i>
        <h4 class="mb-1">{{ $t("export.processing") }}</h4>
        <p class="text-muted mb-0">{{ $t("export.processing_text") }}</p>
      </div>
    </modal>

    <modal
      :show="exportError !== null"
      @close="clearExportError"
      modal-classes="modal-secondary"
    >
      <template slot="header">
        <h5 class="modal-title text-danger">
          <i class="fa fa-exclamation-triangle mr-2"></i>
          {{ exportError && exportError.title }}
        </h5>
      </template>
      <pre
        v-if="exportError && exportError.detail"
        class="export-error-detail"
      >{{ exportError.detail }}</pre>
      <template slot="footer">
        <button type="button" class="btn btn-link ml-auto" @click="clearExportError">
          {{ $t("close") }}
        </button>
      </template>
    </modal>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <div class="row">
              <div class="col-lg-6">
                <h3 class="mb-0">{{ $t("menu.agent_number") }}</h3>
              </div>
              <div class="col-lg-6 text-right">
                <el-select
                  class="select-primary pagination-select"
                  v-model="enterprise_id"
                  filterable
                  v-if="!isCorporateAdmin"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in corporate"
                    :key="item.ID"
                    :label="item.Name"
                    :value="item.ID"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div>
                <base-button
                  @click.native="handleSyncPackageAll()"
                  class="primary"
                  type="warning"
                  size="md"
                  icon
                  v-if="isDtacAdmin"
                >
                  <i class="text-dtac-bt fas fa-sync-alt"></i>
                  {{ $t("number.syncpackage") }}
                </base-button>
              </div>

              <div>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  :placeholder="$t('search')"
                >
                </base-input>
              </div>
            </div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>
              <el-table-column
                v-if="isDtacAdmin || isReadOnly"
                :label="$t('eas_server')"
                min-width="120"
                prop="EasServer"
              >
                <template slot-scope="{ row }">
                  {{ row.EasDisplayName || row.EasServer }}
                </template>
              </el-table-column>
              <el-table-column
                min-width="120px"
                align="right"
                :label="$t('number.charge')"
              >
                <div slot-scope="{ row }" class="d-flex">
                  {{ getChargeNumberType(row) }}
                </div>
              </el-table-column>
              <el-table-column
                :min-width="isDtacAdmin || isReadOnly ? '80px' : '200px'"
                align="right"
                :label="$t('actions')"
                v-if="isDtacAdmin || isCorporateAdmin || isCorporateSuperAdmin || isReadOnly"
              >
                <template slot-scope="{ $index, row }">
                  <el-dropdown
                    v-if="isDtacAdmin || isReadOnly"
                    trigger="click"
                  >
                    <button
                      type="button"
                      class="btn btn-sm btn-icon-only btn-link row-actions-trigger"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-if="isDtacAdmin"
                        @click.native="handleSyncPackage($index, row)"
                      >
                        <i class="fas fa-sync-alt mr-2"></i>
                        {{ $t("number.syncpackage") }}
                      </el-dropdown-item>
                      <el-dropdown-item
                        v-if="isDtacAdmin"
                        @click.native="handleResetPassword($index, row)"
                      >
                        <i class="fa fa-key mr-2"></i>
                        {{ $t("auth.resetpass") }}
                      </el-dropdown-item>
                      <el-dropdown-item
                        @click.native="handleComportal($index, row)"
                      >
                        <i class="fa fa-external-link-alt mr-2"></i>
                        {{ $t("comportal") }}
                      </el-dropdown-item>
                      <el-dropdown-item
                        v-if="isDtacAdmin"
                        @click.native="handleEdit($index, row)"
                      >
                        <i class="fa fa-edit mr-2"></i>
                        {{ $t("edit") }}
                      </el-dropdown-item>
                      <el-dropdown-item
                        v-if="isDtacAdmin"
                        divided
                        @click.native="handleDelete($index, row)"
                      >
                        <span class="text-danger">
                          <i class="fa fa-trash mr-2"></i>
                          {{ $t("delete") }}
                        </span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <div v-else class="d-flex">
                    <base-button
                      @click.native="handleResetPassword($index, row)"
                      class="edit"
                      type="warning"
                      size="sm"
                      icon
                    >
                      {{ $t("auth.resetpass") }}
                    </base-button>
                    <base-button
                      @click.native="handleComportal($index, row)"
                      class="edit"
                      type="warning"
                      size="sm"
                      icon
                    >
                      {{ $t("comportal") }}
                    </base-button>
                    <base-button
                      @click.native="handleEdit($index, row)"
                      class="edit"
                      type="warning"
                      size="sm"
                      icon
                    >
                      <i class="text-dtac-bt fa fa-edit"></i>
                    </base-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            v-if="queriedData.length != 0"
          >
            <div class="">
              <p class="card-category">
                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                {{ $t("of") }}
                {{ total }}
                <span v-if="selectedRows.length">
                  - &nbsp; &nbsp; {{ selectedRows.length }}
                  {{ $t("row_select") }}
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="showAddModal" modal-classes="modal-secondary">
      <form class="new-event--form" @submit.prevent="saveEvent">
        <base-input
          :label="$t('number.charge')"
          input-classes="form-control-alternative new-event--title"
          v-if="isDtacAdmin"
        >
          <el-select
            v-model="md_charge_number"
            :placeholder="$t('number.charge')"
          >
            <el-option
              v-for="option in optionChargeNumber"
              :key="option.label"
              :label="option.label"
              :value="option.value"
            >
            </el-option>
          </el-select>
        </base-input>

        <base-input
          :label="$t('email')"
          v-model="md_email"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

        <input type="hidden" class="new-event--start" />
        <input type="hidden" class="new-event--end" />
      </form>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleUpdate()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showAddModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Select,
  Option,
  Dropdown,
  DropdownMenu,
  DropdownItem
} from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PagingAgent/clientPaginationMixin";
import exportMixin from "./exportMixin";
import { WebPortalService } from "../../resource";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
  mixins: [clientPaginationMixin, exportMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem
  },
  computed: {
    ...mapGetters({
      isCorporateSuperAdmin: "Auth/isCorporateSuperAdmin",
      isCorporateAdmin: "Auth/isCorporateAdmin",
      isDtacAdmin: "Auth/isDtacAdmin",
      isReadOnly: "Auth/isReadOnly",
      tableDataOrg: "AgentNumberV4/getData",
      tableEnterprise: "AgentNumberV4/getData",
      corporate: "Corporate/getDataWithAll"
    }),
    tableData: function() {
      let result = this.tableDataOrg;
      if (this.enterprise_id != 0) {
        result = this.tableDataOrg.filter(m => {
          return m.EnterpriseID == this.enterprise_id;
        });
      }

      return result;
    },
    tableColumns: function() {
      return [
        {
          prop: "Number",
          label: this.$t("menu.number"),
          minWidth: 90,
          sortable: true
        },
        {
          prop: "EnterpriseName",
          label: this.$t("menu.corporate"),
          minWidth: 100,
          sortable: true
        },
        {
          prop: "PackageName",
          label: this.$t("menu.package"),
          minWidth: 120,
          sortable: true
        },
        {
          prop: "Email",
          label: this.$t("email"),
          minWidth: 90,
          sortable: true
        }
      ];
    }
  },
  data() {
    return {
      propsToSearch: ["Number", "Email"],
      selectedRows: [],
      showAddModal: false,
      md_charge_number: 1,
      md_email: "",

      rowEdit: {
        ID: 0,
        Number: ""
      },
      optionChargeNumber: [
        {
          label: this.$t("menu.pilot_number"),
          value: "1"
        },
        {
          label: this.$t("menu.agent_number"),
          value: "2"
        }
      ],
      enterprise_id: 0,
      exportFn: () => WebPortalService.NumberExportV4()
    };
  },
  async mounted() {
    this.listData();
    await this.listCorporate();
    if (this.$route.query.id != null) {
      this.enterprise_id = parseInt(this.$route.query.id);
    }
  },
  methods: {
    ...mapActions("AgentNumberV4", ["resetPassword"]),
    ...mapActions({
      createData: "AgentNumberV4/createData",
      updateData: "AgentNumberV4/updateData",
      deleteData: "AgentNumberV4/deleteData",
      listData: "AgentNumberV4/listData",
      syncPackage: "AgentNumberV4/syncPackage",
      comPortalLogin: "AgentNumberV4/comPortalLogin",
      listCorporate: "Corporate/listData"
    }),
    handleResetPassword(index, row) {
      swal
        .fire({
          title: this.$t("auth.resetpass"),
          text: this.$t("auth.confirm_reset_pass") + row.Number,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.resetPassword({
              number: row.Number
            })
              .then(resp => {
                swal.fire({
                  title: this.$t("auth.resetpass"),
                  text: ``,
                  icon: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false
                });
              })
              .catch(err => {
                swal.fire({
                  title: this.$t("auth.resetpass"),
                  text: this.$t("errors.auth.reset_pass_fail"),
                  icon: "error",
                  confirmButtonClass: "btn btn-danger btn-fill",
                  buttonsStyling: false
                });
              });
          }
        });
    },
    getChargeNumberType(row) {
      if (row.ChargeType == 1) return this.$t("menu.pilot_number");
      else return this.$t("menu.agent_number");
    },
    handleComportal(index, row) {
      this.comPortalLogin({
        number: row.Number,
        locale: this.$i18n.locale,
        type: 2
      })
        .then(res => {
          window.open(res.data.Msg);
        })
        .catch(err => {
          swal.fire({
            title: this.$t(err.response.data.Msg),
            text: this.getErrorText(err.response.data),
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    },
    handleEdit(index, row) {
      this.showAddModal = true;
      this.rowEdit.ID = row.ID;
      this.rowEdit.Number = row.Number;
      this.md_charge_number = row.ChargeType;
      this.md_email = row.Email;
    },
    handleUpdate() {
      this.showAddModal = false;
      this.updateData({
        id: this.rowEdit.ID,
        chargeFrom: this.md_charge_number,
        email: this.md_email
      })
        .then(resp => {
          this.listData();
          swal.fire({
            title: this.$t("edit_success"),
            text: ``,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        })
        .catch(err => {
          swal.fire({
            title: this.$t(err.response.data.Msg),
            text: this.getErrorText(err.response.data),
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    },
    handleDelete(index, row) {
      swal
        .fire({
          title: this.$t("delete_confirm"),
          text:
            this.$t("delete_confirm_question") +
            row.Number +
            " - (" +
            row.EnterpriseName +
            ")",
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.deleteData({
              id: row.ID
            })
              .then(resp => {
                this.listData();
                swal.fire({
                  title: this.$t("delete_success"),
                  text: ``,
                  icon: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false
                });
              })
              .catch(err => {
                swal.fire({
                  title: this.$t(err.response.data.Msg),
                  text: this.getErrorText(err.response.data),
                  icon: "error",
                  confirmButtonClass: "btn btn-danger btn-fill",
                  buttonsStyling: false
                });
              });
          }
        });
    },
    handleSyncPackage(index, row) {
      this.syncPackage(
        JSON.stringify([
          {
            id: row.ID,
            number: row.Number
          }
        ])
      )
        .then(resp => {
          // Reload Package
          this.listData();
          swal.fire({
            title: this.$t("number.sync_package_success"),
            text: ``,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        })
        .catch(err => {
          const data = (err.response && err.response.data) || {};
          swal.fire({
            title: this.$t(data.Msg || "errors.subs.sync_package_fail"),
            text: "",
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    },
    handleSyncPackageAll() {
      const number = [];

      this.queriedData.forEach(row => {
        number.push({
          id: row.ID,
          number: row.Number
        });
      });

      // for (var i = this.from; i < this.to; i++) {
      //   number.push({
      //     id: this.tableData[i].ID,
      //     number: this.tableData[i].Number
      //   });
      // }

      // console.log("Sync All");
      // console.log(number);

      this.syncPackage(JSON.stringify(number))
        .then(resp => {
          this.listData();
          swal.fire({
            title: this.$t("number.sync_package_success"),
            text: ``,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        })
        .catch(err => {
          const data = (err.response && err.response.data) || {};
          swal.fire({
            title: this.$t(data.Msg || "errors.subs.sync_package_fail"),
            text: "",
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    }
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
.export-error-detail {
  background: #fff5f7;
  border: 1px solid #f5365c;
  border-radius: 4px;
  padding: 10px;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 60vh;
  overflow-y: auto;
  margin: 0;
}
</style>
